module.exports = __webpack_public_path__ + "img/TY.4190b2c2.png";